<template>
    <BaseFrame
      cancelText="取消"
      clearText=""
      submitText="提交申请"
      @submit="toSubmitValidate"
    >
      <div class="container" slot="content">
        <lk-card
          title="申请内容"
        >
          <applyContent
            ref="applycon"
            :formObject="applyObject"
            :formRules="rules"
            :fieldData="selectedItem"
            :config="applyContents"
            @change="toGetData"
            @add="selected"
            @attach="toAttach"
            @inputNumChange="handleInpuNumChange"
          >
          </applyContent>
        </lk-card>
      </div>
    </BaseFrame>
  
</template>

<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import applyContent from '../../components/sale/receiveLimitContent.vue';
import goods from '../../services/goods';
import sale from '@/services/sale';
import utils from '../../libs/utils';

export default {
  name: 'receiveableLimitAdd',
  components: {
    BaseFrame,
    applyContent,
  },
  data() {
    return {
      selectedItem: {},
      applyObject: {
        storeName: '',
        remark: '',
        month: '',
        num: 0,
        approvalAmount: '',
        usedMonth: '',
        saleAveNum: '',
        verificationNum: '',
        appliedAmount: '',
        receivablePrice: '',
        receivableTime: null,
      },
      rules: {
        num: [
          { required: true, message: '请输入申请数量' },
        ],
        receivableTime: [
          { required: true, message: '请选择回款时间', type: 'date'},
        ],
        remark: [
          { required: true, message: '请输入申请原因' },
        ],
      },
      applyContents: [
        [
          {
            type: 'span',
            title: '申请门店',
            key: 'storeName'
          },
          {
            type: 'span',
            title: '申请月份',
            isShowOtherTxt: '申请压货数量仅当月有效，在该月结束后自动过期',
            key: 'month',
            style: "width:400px"
          },
        ],
        [
          {
            type: 'inputSearch',
            title: '申请商品',
            value: '',
            prop: 'applyGoods',
            required: true,
            isShowInputSearch: true,
            goodsData: [],
            goodsColumns: [
              { title: '商品编码', key: 'drugSerialCode', width: '65px' },
              { title: '药品通用名', key: 'approvedDrugNames', width: '142px' },
              { title: '商品名', key: 'goodsName', width: '90px' },
              { title: '生产厂家', key: 'manufacturer', width: '65px' },
              { title: '规格', key: 'specifications', width: '142px' },
              { title: '包装单位', key: 'drugMiniPackageUnitString', width: '90px' },
            ],
            showFields: [
              {
                title: '商品编码：',
                key: 'drugSerialCode'
              },
              {
                title: '通用名：',
                key: 'approvedDrugNames'
              },
              {
                title: '商品名：',
                key: 'goodsName'
              },
              {
                title: '规格：',
                key: 'specifications'
              },
              {
                title: '包装单位：',
                key: 'drugMiniPackageUnitString'
              },
              {
                title: '生产厂家：',
                key: 'manufacturer'
              },
              {
                title: '采购价：',
                key: 'purchasePrice',
                style: 'width: 50%'
              },
              {
                title: '零售价：',
                key: 'retailPrice'
              },
              {
                title: '税率：',
                key: 'outputTaxRateStr'
              },
            ],
          }
        ],
        [
          {
            type: 'span',
            title: '未核销应收总数',
            key: 'verificationNum'
          },
          {
            type: 'span',
            title: '本月已申请限额',
            key: 'appliedAmount',
          },
        ],
        [
          {
            type: 'span',
            title: '本月已使用限额',
            key: 'usedMonth',
          },
          {
            type: 'span',
            title: '月均销售数量(近3月)',
            key: 'saleAveNum',
          },
        ],
        [
          {
            type: 'inputNumber',
            title: '本次申请数量',
            style: "width:30%",
            key: 'num',
            prop: 'num',
            placeholder: '请输入',
            min: 0,
            max: 99999,
            precision: 0
          },
          {
            type: 'span',
            key: 'receivablePrice',
            title: '计划应收金额'
          }
        ],
        [
          {
            type: 'date',
            title: '计划回款时间',
            key: 'receivableTime',
            prop: 'receivableTime',
            style: 'width:30%;',
            placeholder: '请输入',
            options: {
              disabledDate (date) {
                return date && date.valueOf() < Date.now() - 86400000;
              }
            }
          },
          {
            type: 'upload',
            title: '附件',
            uploadInfo: [
              {
                appendixName: '',
                appendixUrl: '',
              },
            ]
          }
        ],
        [
          {
            type: 'input',
            title: '申请原因',
            prop: 'remark',
            key: 'remark',
            style: "width:120%",
            inputType: 'textarea',
            rows: 4,
            placeholder: '请输入'
          },
        ]
      ]
    }
  },
  methods: {
    toSubmitValidate() {
      if (!this.selectedItem.drugSerialCode) {
        this.$Message.error('请按要求输入必填项');
        return
      }
      if (!this.applyObject.num) {
        this.$Message.error('本次申请数量不能为0');
        return
      }
      if (!this.selectedItem.purchasePrice) {
        this.$Message.error('请输入采购价');
        return;
      }
      this.$refs.applycon.$refs.form.validate(valid => {
        if (valid) {
          this.submit();
        }
      })
    },
    submit() {
      let params = {
        serialCode: this.selectedItem.drugSerialCode,
        approvalAmount: this.applyObject.num,
        reason: this.applyObject.remark,
        goodsStoreId: this.selectedItem.goodsStoreId,
        bizExtraVos: this.applyContents[5][1].uploadInfo,
        appliedAmount: this.applyObject.appliedAmount,
        saleAveNum: this.applyObject.saleAveNum,
        verificationNum: this.applyObject.verificationNum,
        usedMonth: this.applyObject.usedMonth,
        purchasePrice: this.selectedItem.purchasePrice,
        retailPrice: this.selectedItem.retailPrice,
        outputTaxRate: this.selectedItem.outputTaxRate,
        receivablePrice: this.applyObject.receivablePrice || 0,
        receivableTime: this.applyObject.receivableTime,
      }
      sale.receiveableLimieSubmit(params).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          this.$router.push({ name: 'receiveableLimitApply' });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toGetData() {
      const params = {
        nameMix: this.applyContents[1][0].value,
        isReceivableLimit: 1,
        page: 1,
        size: 20
      }
      goods.listGoodsStores(params).then(res => {
        if (res.data.status === 200) {
          let data = res.data.data.list;
          let list = [];
          data.forEach(item => {
            item.goodsBaseVO.goodsBase.goodsStoreId = item.goodsStoreId;
            list.push(item.goodsBaseVO.goodsBase);
          })
          this.$set(this.applyContents[1][0], 'goodsData', list);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    selected(val) {
      this.selectedItem = val;
      this.$set(this.applyContents[1][0], 'value', '');
      this.getAmountsInfos(val);
    },
    toAttach(val) {
      this.$set(this.applyContents[5][1], 'uploadInfo', val);
    },
    getAmountsInfos(obj) {
      sale.getAmountsInfo({ goodsStoreId: obj.goodsStoreId }).then(res => {
        if (res.data.status === 200) {
          this.applyObject = Object.assign({}, this.applyObject, res.data.data);
          res.data.data.outputTaxRateStr = res.data.data.outputTaxRate === undefined ? '' : `${res.data.data.outputTaxRate}%`;
          this.selectedItem = Object.assign({}, this.selectedItem, res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    handleInpuNumChange(val) {
      if (val === 'num') {
        if (this.selectedItem.retailPrice) {
          let value = (this.selectedItem.retailPrice * this.applyObject.num).toFixed(2);
          this.$set(this.applyObject, 'receivablePrice', value);
        }
      }
    }
  },
  mounted() {
    this.applyObject.storeName = this.$store.state.storeInfo.name || '';
    let date = new Date();
    this.applyObject.month = `${date.getFullYear()}-${date.getMonth()+1 >= 10 ? date.getMonth()+1 : `0${date.getMonth()+1}`}`;
  }
};
</script>

<style lang="less" scoped>
  
</style>
